// extracted by mini-css-extract-plugin
export default {"main_button":"MainButton_main_button__6Vnll","disabled":"MainButton_disabled__1KoOW"};